(function($) {

/* Navigation Toggle
   ========================================================================== */

$(document).on('click', '.navigation-toggle', function(event) {
	event.preventDefault();
	$(this).toggleClass('navigation-toggle-active');
	$('.navigation-collapse').toggleClass('navigation-open');
});

$(document).ready(function ($) {
	
	/* Site Sticky Navigation
	   ========================================================================== */
	
	$(window).on("load scroll resize", function () {
		var stickyWrapper = $("#page");
		var	stickyElement = $("#masthead");
		var	stickyClass = "sticky";

		if ( window.innerWidth > 1023 && $(this).scrollTop() > 176 ) {
			stickyWrapper.addClass(stickyClass);
			stickyElement.addClass(stickyClass);
		} else {
			stickyWrapper.removeClass(stickyClass);
			stickyElement.removeClass(stickyClass);
		}
	});
	
	/* Search Toggle
	   ========================================================================== */

	$(document).on('click', '#masthead .search-form-toggle', function(event) {
		event.preventDefault();
		$('#masthead .search-form-toggle').toggleClass('active');
		$('#masthead .search-form').toggleClass('active');
		$('#masthead .search-field').focus();
	});

	$('body').click(function(e) {
		if ( $('#masthead .search-form').hasClass('active') ) {
			var target = $(e.target);
			if( !target.is('.search-field, .search-submit') ) {
				$('#masthead .search-form-toggle').removeClass('active');
				$('#masthead .search-form').removeClass('active');
			}
		}
	});

	/* Telephone Links
	   ========================================================================== */

	$('.tel[data-phone], .tel .value[data-phone]').each(function () {
		var tel = $(this);
		var link = $('<a/>');

		link.html(tel.html());
		link.attr('href', 'tel:' + tel.data('phone'));
		link.attr('class', tel.attr('class'));

		tel.replaceWith(link);
	});

	/* HTML5 Placeholder
	   ========================================================================== */

	$('input, textarea').placeholder();
	
	/* Slider
	   ========================================================================== */
	
	$('[data-slick]').slick();
	
	/* Video
	   ========================================================================== */
	
	$('.video[data-video]').one('click', function() {
		$(this).html('<iframe src="http://www.youtube.com/embed/'+ $(this).data("video") +'?autoplay=1" allowfullscreen></iframe>');
	});

	/* Tabset
	   ========================================================================== */

	var tabLinks = $('[data-tab]');
	var	tabContents = $('[data-tab-content]');
	var	tabLinkActive = '.tab-link.active';
	var	tabLinkActiveClass = 'active';
	var	tabActiveClass = 'active';

	$('[data-tabset]').each(function () {
		var wrapper = $(this);
		var group = wrapper.data('tab-group');
		var scope = '[data-tab-group=' + group + ']';
		var tabs = tabLinks.filter(scope);
		var content = tabContents.filter(scope);
		var init = wrapper.data('tab-init');
		
		//
		// Init Tab
		//
		
		$('[data-tab]' + scope).each(function (index, a) {
			if ($(a).attr('href') === window.location.hash) {
				// Do nothing
			}
			else {
				tabs.filter('[data-tab='+ init + ']').addClass(tabLinkActiveClass);
				content.filter('[data-tab-content=' + init + ']').addClass(tabActiveClass);
			}
		});
		
		//
		// Tabs
		//
		
		tabs.on('click', function (event) {
			var tab = $(this);
			var	activeTab = tab.data('tab');
			
			if (wrapper.hasClass('tabset-responsive') && window.innerWidth < 768) {
				tabs.filter('[data-tab='+ activeTab +']').toggleClass(tabLinkActiveClass);
				content.filter('[data-tab-content=' + activeTab + ']').toggleClass(tabActiveClass).end();
			}
			else {
				tabs.removeClass(tabLinkActiveClass).filter('[data-tab='+ activeTab +']').addClass(tabLinkActiveClass);
				content.removeClass(tabActiveClass).filter('[data-tab-content=' + activeTab + ']').addClass(tabActiveClass);
			}
			
			$(window).on('load resize', function () {
				if (window.innerWidth > 767) {
					tabs.removeClass(tabLinkActiveClass).filter('[data-tab='+ activeTab +']').addClass(tabLinkActiveClass);
					content.css('display', '').removeClass(tabActiveClass).filter('[data-tab-content=' + activeTab + ']').addClass(tabActiveClass);
				}
			}).resize();
			
			if (tab.hasClass('tab-link')) {
				event.preventDefault();
			}
			$.fn.matchHeight._update(); // Update match height
		});
		
		//
		// Pevious Tab
		//
		
		wrapper.on('click', '[data-tab-prev]' + scope, function (event) {
			for (var i = tabs.length - 1; i >= 0; i--) {
				var tab = tabs.eq(i);

				if (tab.is(tabLinkActive)) {
					tabs.eq(i - 1).trigger('click');

					break;
				}
			}
			
			$.fn.matchHeight._update(); // Update match height
			event.preventDefault();
		});
		
		//
		// Next Tab
		//
		
		wrapper.on('click', '[data-tab-next]' + scope, function (event) {
			for (var i = 0, last = tabs.length; i < last; i++) {
				var tab = tabs.eq(i);
		
				if (tab.is(tabLinkActive)) {
					tabs.eq((i + 1) % last).trigger('click');
					break;
				}
			}
			
			$.fn.matchHeight._update(); // Update match height
			event.preventDefault();
		});
		
		//
		// Hash Tab
		//
		
		$(window).on('hashchange load', function () {
			$('[data-tab]' + scope).each(function (index, a) {
				var tab = $(this);
				var	activeTab = tab.data('tab');
				
				if ($(a).attr('href') === window.location.hash && window.location.href) {
					tabs.removeClass(tabLinkActiveClass).filter('[data-tab='+ activeTab +']').addClass(tabLinkActiveClass);
					content.removeClass(tabActiveClass).filter('[data-tab-content=' + activeTab + ']').addClass(tabActiveClass);
					$(document).scrollTop( $(this).offset().top );  
					
					$.fn.matchHeight._update(); // Update match height
				}
			});
		});
	});

	/* Accordion
	   ========================================================================== */

	var accordion = '[data-accordion]';
	var	accordionHeader = '[data-accordion-header]';
	var	accordionContent = '[data-accordion-content]';
	var	accordionActiveClass = 'active';

	$(accordion)
	.find(accordionContent).hide().end()
	.find(accordionHeader +':first').addClass(accordionActiveClass).end()
	.find(accordionContent +':first').show().end()
	.on('click', accordionHeader, function (event) {
		var self = $(this);
		var	accordionBody = self.closest(accordion);

		if (!self.hasClass(accordionActiveClass)) {
			accordionBody
			.find(accordionHeader).removeClass(accordionActiveClass).end()
			.find(accordionContent).slideUp().end();

			self.addClass(accordionActiveClass)
			.next(accordionContent).slideDown(function(){
				$.fn.matchHeight._update(); // Update match height
			}).end();
		}

		event.preventDefault();
	});
	
	/* Tooltip
	   ========================================================================== */
	
	$('[data-tooltip]')
	.mouseenter(function() {	
		var title = $(this).attr('title');
		$(this).attr('temp_title', title);
		$(this).attr('title','');
	})
	.mouseleave(function() {
		var title = $(this).attr('temp_title');
		$(this).attr('title', title);
	})
	.click(function() {	
		var title = $(this).attr('temp_title');
		$(this).attr('title', title);
	});

	/* Gallery
	   ========================================================================== */
	
	$('.gallery-thumbnail a').attr('rel','gallery');
	
	$('.gallery a').fancybox({
		maxWidth	: 760,
		maxHeight	: '100%',
		fitToView	: true,
		margin      : 16,
		padding     : 4,
		width		: '100%',
		height		: 'auto',
		autoSize	: false,
		closeClick	: false,
		openEffect	: 'none',
		closeEffect	: 'none',
		helpers : {
			thumbs : {
				width  : 48,
				height : 48
			}
		}
	});
	
	/* Fancybox
	   ========================================================================== */
	
	$('.fancybox').fancybox({
		maxWidth	: 760,
		maxHeight	: '100%',
		fitToView	: true,
		margin      : 16,
		padding     : 4,
		width		: '100%',
		height		: 'auto',
		autoSize	: false,
		closeClick	: false,
		openEffect	: 'none',
		closeEffect	: 'none'
	});
	
	/* Footer Newsletter Form
	   ========================================================================== */
	
	var $newsletter = $('.newsletter-form');

	$newsletter.on('click', '.btn', function () {
		$newsletter.addClass('newsletter-form-validate');
	});

	$newsletter.on('submit', function (e) {
		e.preventDefault();

		$newsletter.removeClass('newsletter-form-validate')
			.find('.btn').addClass('btn-disabled')
				.children('span').attr('class', 'icon-spinner2');

		$.post($newsletter.attr('action'), $newsletter.serialize())
			.done(function (data) {
				if (!data.success) {
					alert(data.message || data.response);
				} else {
					alert('You are now subscribed!');
					$newsletter.find('.field').val('');
				}
			})
			.fail(function (data) {
				alert(data.message || 'There was an error subscribing you to our newsletter.');
				console.log(data);
			})
			.always(function () {
				$newsletter.find('.btn').removeClass('btn-disabled')
					.children('span').attr('class', 'icon-arrow-right3');
			}, 'json');
	});

	/* Anchor Offset
	   ========================================================================== */
	
	function fixedHeaderOffset( screenWidth ) 
	{
		if ( screenWidth < 1024 ) {
			return 64;
		}
		else {
			return 0;	
		}
	}

	// Run on first scroll (in case the user loaded a page with a hash in the url)
	window.addEventListener('scroll', onScroll);
	function onScroll()
	{
		window.removeEventListener('scroll', onScroll);
		scrollUpToCompensateForFixedHeader();
	}

	// Run on hash change (user clicked on anchor link)
	if ( 'onhashchange' in window ) {
		window.addEventListener('hashchange', scrollUpToCompensateForFixedHeader);
	}

	function scrollUpToCompensateForFixedHeader()
	{
		var hash, 
			target;

		// Get hash, e.g. #mathematics
		hash = window.location.hash;
		if ( hash.length < 2 ) { return; }

		// Get :target, e.g. <h2 id="mathematics">...</h2>
		target = document.getElementById( hash.slice(1) );
		if ( target === null ) { return; }

		// Get distance of :target from top of viewport. If it's near zero, we assume
		// that the user was just scrolled to the :target.
		if ( target.getBoundingClientRect().top < 2 ) {
			window.scrollBy(0, -fixedHeaderOffset());
		}
	}
		
}); // end.ready

}(jQuery));

/* Skip to Content
   ========================================================================== */

/**
 * Makes "skip to content" link work correctly in IE9, Chrome, and Opera
 * for better accessibility.
 *
 * @link http://www.nczonline.net/blog/2013/01/15/fixing-skip-to-content-links/
 */

 ( function() {
	var isWebkit = navigator.userAgent.toLowerCase().indexOf( 'webkit' ) > -1,
		isOpera  = navigator.userAgent.toLowerCase().indexOf( 'opera' )  > -1,
		isIE     = navigator.userAgent.toLowerCase().indexOf( 'msie' )   > -1;

	if ( ( isWebkit || isOpera || isIE ) && document.getElementById && window.addEventListener ) {
		window.addEventListener( 'hashchange', function() {
			var id = location.hash.substring( 1 ),
				element;

			if ( ! ( /^[A-z0-9_-]+$/.test( id ) ) ) {
				return;
			}

			element = document.getElementById( id );

			if ( element ) {
				if ( ! ( /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) ) {
					element.tabIndex = -1;
				}

				element.focus();

				// Repositions the window on jump-to-anchor to account for admin bar and border height.
				window.scrollBy( 0, 0 );
			}
		}, false );
	}
} )();
